import { render } from "./RequestAnnualLeave.vue?vue&type=template&id=6cfc2a3a"
import script from "./RequestAnnualLeave.vue?vue&type=script&lang=js"
export * from "./RequestAnnualLeave.vue?vue&type=script&lang=js"

import "./RequestAnnualLeave.vue?vue&type=style&index=0&id=6cfc2a3a&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6cfc2a3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cfc2a3a', script)) {
    api.reload('6cfc2a3a', script)
  }
  
  module.hot.accept("./RequestAnnualLeave.vue?vue&type=template&id=6cfc2a3a", () => {
    api.rerender('6cfc2a3a', render)
  })

}

script.__file = "src/views/AnnualLeave/RequestAnnualLeave.vue"

export default script